.overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.4);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.overlay p {
  color: #666;
  font-size: 18px;
  padding: 0 5em;
  text-align: center;
}
.overlay aha-icon {
  font-size: 36px;
}
